import { useState } from "react";
import { Play } from "lucide-react";
import { REELS } from "@/lib/content";
import { StoryViewer } from "./StoryViewer";

const KEY = "fx-seen-stories";
const readSeen = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

export const Stories = ({ title = "FX Hikayeler" }) => {
  const [open, setOpen] = useState(null);
  const [seen, setSeen] = useState(readSeen);
  const markSeen = (id) => setSeen((s) => {
    if (s.includes(id)) return s;
    const n = [...s, id];
    localStorage.setItem(KEY, JSON.stringify(n));
    return n;
  });

  return (
    <section data-testid="stories-section" className="border-b border-white/10 bg-black">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <div className="mb-6 flex items-center justify-between">
          <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-neutral-400"><span className="h-[2px] w-8 bg-brand" />{title}</p>
          <button onClick={() => setOpen(0)} data-testid="stories-play-all-btn" className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:text-brand"><Play className="h-4 w-4" /> Hepsini izle</button>
        </div>
        <div className="-mx-5 flex gap-5 overflow-x-auto px-5 pb-2 [scrollbar-width:none] md:mx-0 md:px-0">
          {REELS.map((r, i) => {
            const isSeen = seen.includes(r.id);
            return (
              <button key={r.id} onClick={() => setOpen(i)} data-testid={`story-bubble-${r.id}`} className="group flex w-20 shrink-0 flex-col items-center gap-2 md:w-24">
                <span className={`rounded-full p-[3px] transition-transform group-hover:scale-105 ${isSeen ? "bg-white/20" : "bg-gradient-to-tr from-brand via-[#ff4d4d] to-white"}`}>
                  <span className="block rounded-full bg-black p-[3px]">
                    <img src={r.poster} alt={r.title} loading="lazy" className="h-[68px] w-[68px] rounded-full object-cover md:h-[84px] md:w-[84px]" />
                  </span>
                </span>
                <span className={`w-full truncate text-center text-xs ${isSeen ? "text-neutral-500" : "text-neutral-200"}`}>{r.label}</span>
              </button>
            );
          })}
        </div>
      </div>
      {open !== null && <StoryViewer items={REELS} start={open} onClose={() => setOpen(null)} onSeen={markSeen} />}
    </section>
  );
};
